import React from "react"
import clsx from "clsx"
import { Icon } from "@silversea-ssc/ui-components-react"
import { match } from "ts-pattern"
import styles from "./Step.module.scss"

export type StepState = "disabled" | "active" | "active-completed" | "completed"

type StepProps = {
    onClick?: () => void
    dataContentPiece: string
    state: StepState
    index: number
}
export const Step: React.FC<React.PropsWithChildren<StepProps>> = ({
    children,
    onClick,
    dataContentPiece,
    state,
    index,
}) => {
    const onClickInner = state == "disabled" ? undefined : onClick
    return (
        <div
            className={clsx(styles.step, classNameForState(state))}
            aria-selected={state == "active"}
            onClick={onClickInner}
            data-content-piece={dataContentPiece}
        >
            <React.Fragment>
                {state == "completed" || state == "active-completed" ? (
                    <Icon name="check" padding={false} size="1.5x" wrapperClassName={styles.icon} />
                ) : (
                    <IconNumber number={index + 1} />
                )}
                <div className={styles.stepLabel}>{children}</div>
            </React.Fragment>
        </div>
    )
}

type IconNumberProps = {
    number: number
}

const IconNumber: React.FC<IconNumberProps> = ({ number }) => {
    return <div className={clsx(styles.icon, styles.iconNumber)}>{number}</div>
}

const classNameForState = (state: StepState) =>
    match<StepState, string>(state)
        .with("disabled", () => styles.stepDisabled)
        .with("active", () => styles.stepActive)
        .with("active-completed", () => styles.stepActiveCompleted)
        .with("completed", () => styles.stepCompleted)
        .exhaustive()
